import { observer } from 'mobx-react-lite'
import React from 'react'
import { Button, Typography } from 'shared/ui'
import { useNumbersLayerContext } from 'pages/settings/pages/numbers/context/numbersLayerContext'
import styles from './styles.module.scss'

export const ImportTwilioNumbersEmpty = observer(() => {
  const { redirectToRoot } = useNumbersLayerContext()

  return (
    <div className={styles.empty}>
      <div className={styles.block}>
        <Typography
          ariaLabel={'No new Twilio numbers to import'}
          variant={'body-lg-medium'}
          marginBottom={8}
        >
          No new Twilio numbers to import
        </Typography>
        <Typography
          ariaLabel={'desc'}
          variant={'body-md-regular'}
          color={'var(--content-primary-tertiary)'}
          className={styles.desc}
        >
          Looks like all your Twilio numbers have already been imported into Salesmsg
        </Typography>
      </div>
      <div className={styles.action}>
        <Button
          fullWidth
          contained={'primary'}
          size={'medium'}
          onClick={redirectToRoot}
          text={'Close'}
        />
      </div>
    </div>
  )
})
